import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { KfmSignatureFieldComponent } from '../signature-field/kfm-signature-field.component';
import { HsLayerModule } from '@hsetu/ngui-resources';
import { HsButtonModule } from '@hsetu/ngui-components';

@Component({
  selector: 'kfm-signature-dialog',
  imports: [
    CommonModule,
    KfmSignatureFieldComponent,
    HsLayerModule,
    HsButtonModule,
  ],
  templateUrl: './kfm-signature-dialog.component.html',
})
export class KfmSignatureDialogComponent {
  private readonly _data = inject<{
    imgDataUrl: string | null;
    lineWidth: number;
    strokeStyle: string;
    lineCap: CanvasLineCap;
    width: number;
    height: number;
  }>(DIALOG_DATA);

  protected readonly dialogRef = inject<DialogRef<string | null>>(
    DialogRef<string | null>,
  );

  protected get imgDataUrl() {
    return this._data && this._data.imgDataUrl ? this._data.imgDataUrl : null;
  }

  protected get lineWidth() {
    return this._data && this._data.lineWidth ? this._data.lineWidth : 2;
  }

  protected get strokeStyle() {
    return this._data && this._data.strokeStyle
      ? this._data.strokeStyle
      : '#000000';
  }

  protected get lineCap() {
    return this._data && this._data.lineCap ? this._data.lineCap : 'round';
  }

  protected get width() {
    return this._data && this._data.width ? this._data.width : 400;
  }

  protected get height() {
    return this._data && this._data.height ? this._data.height : 200;
  }

  @ViewChild('signatureField', { static: true })
  protected signatureField!: KfmSignatureFieldComponent;
}
